import { COOKIE_CONSENTS_COOKIE_2_NAME, COOKIE_CONSENTS_COOKIE_NAME, LANGUAGE_COOKIE_NAME, THEME_COOKIE_NAME, UTM_PARAMS_COOKIE_NAME, WFW_REGISTER_LOGIN_COOKIE_NAME, WOLT_DEVICE_COOKIE_NAME, WOLT_SESSION_COOKIE_NAME, WOLT_UID_COOKIE_NAME, } from './constants';
function getCookieName(type, options) {
    switch (type) {
        case 'language':
            return LANGUAGE_COOKIE_NAME;
        case 'theme':
            return THEME_COOKIE_NAME;
        case 'cookie-consents':
            return (options === null || options === void 0 ? void 0 : options.version) === 2 ? COOKIE_CONSENTS_COOKIE_2_NAME : COOKIE_CONSENTS_COOKIE_NAME;
        case 'wolt-uid':
            return WOLT_UID_COOKIE_NAME;
        case 'session-uid':
            return WOLT_SESSION_COOKIE_NAME;
        case 'device-fingerprint':
            return WOLT_DEVICE_COOKIE_NAME;
        case 'wfw-register':
            return WFW_REGISTER_LOGIN_COOKIE_NAME;
        case 'utm-params':
            return UTM_PARAMS_COOKIE_NAME;
    }
}
export { getCookieName };
